import { Component, effect, ElementRef, input, InputSignal, viewChild } from '@angular/core';
import { AbcIconCacheService } from './abc-icon-cache.service';

@Component({
  selector: 'abc-icon',
  imports: [],
  template: `<div #icon [style.fill]="color()" class="icon"></div>`,
  styles: `
    :host ::ng-deep {
      display: block;
      user-select: none;

      .icon {
        width: inherit;
        height: inherit;

        svg {
          width: inherit;
          height: inherit;
          fill: inherit;

          path {
            fill: inherit;
          }
        }
      }
    }
  `,
})
export class AbcIconComponent {
  public icon = viewChild<ElementRef<HTMLElement>>('icon');

  public svgIcon: InputSignal<string> = input('');
  public color: InputSignal<string> = input('');
  public width: InputSignal<string> = input('25px');
  public height: InputSignal<string> = input('25px');

  constructor(private cacheService: AbcIconCacheService) {
    effect(this.handler);
  }

  private handler = async (): Promise<void> => {
    if (this.icon()) {
      const svgIcon = this.svgIcon();
      const iconElement = this.icon().nativeElement;
      const cachedIcon = this.cacheService.cache().get(svgIcon);

      iconElement.parentElement.style.width = this.width();
      iconElement.parentElement.style.height = this.height();

      if (!svgIcon || !svgIcon.length) {
        return;
      }

      if (svgIcon.includes('<svg')) {
        iconElement.innerHTML = svgIcon;
      } else if (cachedIcon) {
        iconElement.innerHTML = cachedIcon;
      } else {
        try {
          const response = await fetch(svgIcon);
          const svgText = await response.text();

          this.cacheService.cache().set(svgIcon, svgText);
          iconElement.innerHTML = svgText;
        } catch (err) {
          console.error('Failed to fetch SVG:', err);
          iconElement.innerHTML = '';
        }
      }
    }
  };
}
